// Local dev environment for LEGACY (legacyconnect.co.in) theme
// Usage: npm run start:legacy  |  ng serve --configuration=legacy
export const environment = {
  production: false,
  theme: 'legacy' as 'legacy' | 'society' | 'austin' | 'mangalam' | 'relationnest',
  appName: 'Legacy Care',
  tabTitle: 'Legacy Care - Simplified Society Management App',
  logoPath: 'assets/Images/page1.png',
  domainUrl: 'https://legacyconnect.co.in/',
  baseUrl: 'https://legacyconnect.co.in/api/public/api',
  storageUrl: 'https://legacyconnect.co.in/api/storage/app/',
  enquiryFormUrl: 'https://legacyconnect.co.in/public/php',

  // domainUrl: 'https://society-dev.portalwiz.in',
  // baseUrl: 'https://society-dev.portalwiz.in/api/public/api',
  // storageUrl: 'https://society-dev.portalwiz.in/api/storage/issue_images/',
  // enquiryFormUrl: 'https://society-dev.portalwiz.in/php',
};
